import { Injectable } from '@angular/core';
import { BaseApiDataService } from 'app/core/storage/base-api-data.service';
import { OdqDateTime } from 'app/shared/model/odq-datetime.model';
import { Observable } from 'rxjs';
import { environment } from '~env';
import { MemberResidenceToAdd, MemberResidenceToChange } from './models/member-residence.model';
const API_URL = environment.registrarCommandApi;

@Injectable({
  providedIn: 'root',
})
export class MemberResidenceCommandService {
  constructor(private dataService: BaseApiDataService<any>) { }

  createFutureResidence(memberId: string, residence: MemberResidenceToAdd): Observable<any> {
    const residenceToAdd: any = { ...residence };
    residenceToAdd.effectiveOn = residence.effectiveOn.toRfc3339();
    return this.dataService.post(`${API_URL}/member/${memberId}/residence/register`, residenceToAdd);
  }

  correctAddress(memberId: string, residence: MemberResidenceToChange): Observable<any> {
    return this.dataService.post(`${API_URL}/member/${memberId}/residence/${residence.id}/correct-information`,
      {
        addressDetail: residence.addressDetail,
        effectiveOn: residence.effectiveOn.toRfc3339(),
        municipalityCode: residence.municipalityCode,
        phone: residence.phone,
        phone2: residence.phone2,
      });
  }

  cancelFutureResidence(memberId: string, residenceId: string, effectiveDate: OdqDateTime,
    confirmDeleteDomicileProfessionel?: boolean, domicileProfessionelToDeleteId?: string): Observable<any> {
    return this.dataService.post(`${API_URL}/member/${memberId}/residence/${residenceId}/cancel`,
      { EffectiveOn: effectiveDate.toRfc3339(), confirmDeleteDomicileProfessionel, domicileProfessionelToDeleteId });
  }
}
